import EventEmitter from "eventemitter3";

const authEventEmitter = new EventEmitter();

export const getAuthEvents = () => authEventEmitter;

export const emitLogout = () => {
  authEventEmitter.emit("logout", {});
};



// WEBPACK FOOTER //
// ./src/lib/authEvents.js